import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./ProductsUrlsModal.module.scss";
import { Modal } from "@/frontend/shared/ui/Modal";
import { MoveIcon } from "@/frontend/shared/assets/icons";

export function ProductsUrlsModal({ isOpen, onClose, urls }: { isOpen: boolean; onClose: () => void; urls: string[] }) {
  return (
    <div className={styles.mainContainer}>
      <Modal className={styles.modal} isOpen={isOpen} onClose={onClose} title="Sources" width="600px">
        <div className={styles.container}>
          <div className={styles.urlsContainer}>
            {urls?.map((url, index) => (
              <a className={styles.url} href={url} key={index} target="_blank" rel="noreferrer">
                <Typography variant="body-3" color="greyscale700" className={styles.urlText}>
                  {url}
                </Typography>
                <MoveIcon />
              </a>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
}
